import React, { useState, useEffect, useRef } from "react";
import { API_URL } from "../config";
import { Link, useSearchParams } from "react-router-dom";
import NoticePage from "../components/NoticePage";

function EmailConfirmation() {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [searchParams] = useSearchParams(); 
    const token = searchParams.get("token");
    const hasCalledAPI = useRef(false);

    useEffect(() => {
        const confirmEmail = async () => {
            // Prevent duplicate API calls
            if (hasCalledAPI.current) return; 
            hasCalledAPI.current = true;
            try {
                const response = await fetch(`${API_URL}/auth/email-confirmation?token=${token}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                });

                const data = await response.json();

                if (response.ok) {
                    setError("")
                    setSuccessMessage(data.message || "Email confirmed successfully.");
                } else {
                    setError(data.message || "Failed to confirm email.");
                }
            } catch (err) {
                setError("An unexpected error occurred. Please try again.");
            } finally {
                setLoading(false);
            }
        };

        if (token) {
            confirmEmail();
        } else {
            setError("Invalid token. Please check your email for a valid link.");
            setLoading(false);
        }
    }, [token]);

    if (loading) {
        return (
            <NoticePage icon="mail" title="Confirming your email">
                <p className="cf-muted">Validating your email...</p>
            </NoticePage>
        );
    }

    if (error) {
        return (
            <NoticePage icon="warning" tone="bad" title="We could not confirm your email">
                <p className="cf-muted">{error}</p>
                <div className="cf-cta-row is-centered">
                    <Link to="/login" className="cf-btn cf-btn-primary">Back to sign in</Link>
                </div>
            </NoticePage>
        );
    }

    return (
        <NoticePage icon="check" title="Email confirmed">
            <p className="cf-muted">{successMessage}</p>
            <div className="cf-cta-row is-centered">
                <Link to="/login" className="cf-btn cf-btn-primary">Go to sign in</Link>
            </div>
        </NoticePage>
    );
}

export default EmailConfirmation;
